module.exports = "A search box (`SearchBox`) provides an input field for searching content within a site or app to find specific items.\n"